import React, { useState, useMemo } from 'react';
import './UrbanPop.css';
import { paginateMenu } from '../../../utils/menuPagination';
import { exportPtPagesToPdf } from '../../../utils/exportPtPagesToPdf';
import ExportPdfFab from '../../../components/ExportPdfFab';

const UrbanPop = ({ data, isSingleMenu }) => {
    const restaurant = data?.restaurant || {};
    const rawMenus = data?.menus || [];

    const [activeMenuIndex, setActiveMenuIndex] = useState(0);

    // Determine which pages to display
    const visiblePages = useMemo(() => {
        if (isSingleMenu) {
            return rawMenus.flatMap(menu => paginateMenu(menu));
        }
        const activeMenu = rawMenus[activeMenuIndex];
        return activeMenu ? paginateMenu(activeMenu) : [];
    }, [isSingleMenu, rawMenus, activeMenuIndex]);

    const handleNext = () => {
        if (activeMenuIndex < rawMenus.length - 1) {
            setActiveMenuIndex(p => p + 1);
            window.scrollTo(0, 0);
        }
    };

    const handlePrev = () => {
        if (activeMenuIndex > 0) {
            setActiveMenuIndex(p => p - 1);
            window.scrollTo(0, 0);
        }
    };

    if (!data) return <div className="loading">Loading...</div>;

    return (
        <div className="up-root">
            {/* Navigation - Only show in Multi-Menu Mode (Preview) */}
            {!isSingleMenu && (
                <div className="tmpl-nav-container no-print" style={{ justifyContent: 'center' }}>
                    <div className="tmpl-nav-controls">
                        <button className="tmpl-nav-btn" onClick={handlePrev} disabled={activeMenuIndex === 0}>
                            ← Prev Menu
                        </button>
                        <div className="tmpl-page-indicator">
                            {rawMenus[activeMenuIndex]?.name || `Menu ${activeMenuIndex + 1}`}
                            <span style={{ fontSize: '0.8em', opacity: 0.7, marginLeft: '8px' }}>
                                ({activeMenuIndex + 1}/{rawMenus.length})
                            </span>
                        </div>
                        <button className="tmpl-nav-btn" onClick={handleNext} disabled={activeMenuIndex === rawMenus.length - 1}>
                            Next Menu →
                        </button>
                    </div>
                </div>
            )}

            <ExportPdfFab onClick={() => exportPtPagesToPdf({ filename: `${restaurant.name || 'menu'}-urban-pop.pdf` })} />

            <div className="up-container">
                {visiblePages.map((page, index) => {
                    const categories = (page.categories || []);

                    // Header logic:
                    // PDF: Only on very first page
                    // Preview: On first page of the active menu
                    const showHeader = isSingleMenu ? (index === 0) : (page.chunkIndex === 0);

                    // Menu Title Logic: Only show on first page of the menu chunk
                    const showMenuTitle = page.chunkIndex === 0;

                    return (
                        <div key={`${page.id || page.name}-${index}`} className="up-page pt-page active">
                            {showHeader && (
                                <div className="up-sidebar">
                                    <div className="up-logo-container">
                                        <h1 className="up-name">{restaurant.name}</h1>
                                    </div>
                                    <div className="up-sidebar-info">
                                        <p>{restaurant.address}</p>
                                        <p>{restaurant.phoneNumber}</p>
                                    </div>
                                </div>
                            )}

                            <div className="up-main">
                                <header className="up-header">
                                    {showMenuTitle && (
                                        <h2 className="up-menu-title">{page.name}</h2>
                                    )}
                                </header>

                                <div className="up-body">
                                    {categories.map(category => (
                                        <div key={category.id} className="up-category">
                                            <h3 className="up-category-title">{category.name}</h3>
                                            <div className="up-items">
                                                {(category.items || []).map(item => (
                                                    <div key={item.id} className="up-item">
                                                        <div className="up-item-header">
                                                            <div className="up-item-name-group">
                                                                {(item.isVeg !== undefined && item.isVeg !== null) && (
                                                                    <span className={`up-veg-badge ${item.isVeg ? 'veg' : 'nonveg'}`}>
                                                                        <span className="up-veg-mark"></span>
                                                                    </span>
                                                                )}
                                                                <span className="up-item-name">{item.name}</span>
                                                            </div>
                                                            <span className="up-item-price">₹{item.price}</span>
                                                        </div>
                                                        {item.description && <p className="up-item-desc">{item.description}</p>}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default UrbanPop;
